import { Copy } from '../copy/Copy';
import { APP_PATHS } from './paths';

export const FOOTER_LIST_ITEMS = [
  {
    name: Copy.generate('FooterList.listItem.1'),
    to: APP_PATHS.pvg,
  },
];
